import * as React from "react";
import {Control, Field, Input} from "bloomer";
import getWordsCount from "../../../../../utils/WordsCount";
import SectionName from "../../../../../elements/SectionName";
import InputWarning from "../../../../../elements/InputWarning";
import WordsLabel from "../../../../../elements/WordsLabel";
import {INVALID_FIELD_STYLE} from "../../../../../utils/Constants";

interface IQuestionAnsweringModelInputProps {
  showUserInputsOnly: boolean;
}

interface IQuestionAnsweringModelInputState {
  questionInput: string;
  questionInputEmpty: boolean;
  questionWordsCount: number;
  showQuestionInputLimitWarning: boolean;
}

class QuestionAnsweringModelInput extends React.Component<IQuestionAnsweringModelInputProps, IQuestionAnsweringModelInputState> {
  public QUESTION_WORDS_LIMIT = 50;

  constructor(props: IQuestionAnsweringModelInputProps) {
    super(props);

    this.state = {
      questionInput: "",
      questionInputEmpty: false,
      questionWordsCount: 0,
      showQuestionInputLimitWarning: false
    };
  }

  public updateQuestionWordsCount = async () => {
    const questionWordsCount = getWordsCount(this.state.questionInput);
    this.setState({
      questionWordsCount,
      showQuestionInputLimitWarning: questionWordsCount > this.QUESTION_WORDS_LIMIT
    });
  };

  public handleQuestionInputChange = (e:any) => {
    this.setState({
      questionInput: e.target.value,
      questionInputEmpty: false
    }, async () => {
      await this.updateQuestionWordsCount();
    });
  };

  public validateForm = () => {
    if (!this.state.questionInput.trim() || this.state.showQuestionInputLimitWarning) {
      if (!this.state.questionInput.trim()) {
        this.setState({
          questionInputEmpty: true
        });
      }
      return false;
    }
    return true;
  };

  public getFormData = (modelNamePrefix: string) => {
    const formData = new FormData();
    formData.append(`${modelNamePrefix}.question`, this.state.questionInput.trim());
    return formData;
  };

  public resetForm = () => {
    this.setState({
      questionInput: "",
      questionInputEmpty: false,
      questionWordsCount: 0,
      showQuestionInputLimitWarning: false
    });
  };

  public render() {
    return (
        <React.Fragment>
            <SectionName>Question</SectionName>
            <Field>
              <Control>
                <Input
                    style={(this.state.questionInputEmpty || this.state.showQuestionInputLimitWarning) ? INVALID_FIELD_STYLE : undefined}
                    onChange={this.handleQuestionInputChange}
                    onPaste={this.handleQuestionInputChange}
                    value={this.state.questionInput}
                    placeholder="Enter your question here"
                />
                <div>
                  {
                    this.state.questionInputEmpty && <InputWarning>Please input a question.</InputWarning>
                  }
                  {
                    this.state.showQuestionInputLimitWarning && <InputWarning>Input size limit has been exceeded. Please decrease the size.</InputWarning>
                  }
                  <WordsLabel>{this.state.questionWordsCount}&nbsp;{this.state.questionWordsCount > 1 ? 'words' : 'word'}</WordsLabel>
                </div>
              </Control>
            </Field>
        </React.Fragment>
    );
  }
}

export default QuestionAnsweringModelInput;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/CrossProvider/input/QuestionAnswering/QuestionAnsweringModelInput.tsx